export var themes = ['b2c_primary', 'b2b_primary'];
export var gradients = ['seagreen', 'aquamarine'];